import { FC, useMemo } from 'react';
import { GaugeChart, HexColor, LayoutCarousel } from '@silverfort/sf-components';
import { LocalAccountsInsights } from '../../../types/LocalAccountsInsights';

interface Props {
    localAccountsInsights?: LocalAccountsInsights;
    isLoading: boolean;
}

const MINIMUM_VALUE = 0.1;

const BoundAccountsStatisticsCard: FC<Props> = ({ localAccountsInsights, isLoading }) => {
    const boundAccounts = useMemo(() => {
        const totalBoundLocalAccounts = localAccountsInsights?.boundLocalAccounts || 0;
        const totalBoundPer = totalBoundLocalAccounts / (localAccountsInsights?.totalLocalAccounts || 1) * 100;
        const value = totalBoundPer > 0 ? Math.max(totalBoundPer, MINIMUM_VALUE) : 0;
        const isLowerThen = value === MINIMUM_VALUE;
        
        return {
            value: parseFloat(value.toFixed(2)),
            label: 'Bound',
            startColor: '#BF1052' as HexColor,
            endColor: '#F1BBCF' as HexColor,
            tooltipContent: `Bound local accounts: ${totalBoundLocalAccounts}`,
            lowerThen: isLowerThen
        };
    }, [localAccountsInsights]);

    return (
        <LayoutCarousel
            title="Bound accounts"
            contentClassName="flex flex-1 flex-col justify-center px-6"
            pages={<GaugeChart {...boundAccounts} isLoading={isLoading} />}
        />
    );
};

export default BoundAccountsStatisticsCard;
